/* eslint-disable react/no-array-index-key */
/* eslint-disable import/no-cycle */
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable array-callback-return */
/* eslint-disable react/jsx-first-prop-new-line */
/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable @typescript-eslint/space-infix-ops */
import React, { useEffect, useState } from 'react';
import '@fortawesome/fontawesome-free/css/all.css';
import OptionMenu from './optionmenu.component';
import { usePADomainModel } from '../../context/ctxPriorAuthorizationDomain';
import './procedure.component.css';

export type itemsprops = {
  procedureStartDate: string,
  unitType: string,
  unitFrequency: string,
  modifier: string,
  modifier2: string,
  procedureCode: string,
  cptCode: string,
  lob: string,
  processedBy: string,
  NDCCode: string,
  drugName: string,
  doseQty: number | null,
  doseQtyUnit: string,
  route: string,
  frequency: string,
  adjustedDrugDosage : string | null
};

export interface ProcedureProps {
  admissionStartDate: string
  serviceDetailIndex: number
  items: itemsprops[]
  setProcedureValues: (procedureValues: any) => any
  serviceType : string
}
const Procedure: React.FC<ProcedureProps> = ({ items, setProcedureValues, serviceDetailIndex, admissionStartDate, serviceType }) => {
  const { updateProcedureCodes, updateProcedureValidationStatus } = usePADomainModel();
  const [isDisabled, setIsDisabled] = useState(false);

  const [ProcedureSet, setProcedureSet] = useState<itemsprops[]>(items);

  useEffect(() => {
    items.map((proc, index) => {
      if (proc.cptCode === '') {
        setIsDisabled(true);
        updateProcedureValidationStatus(serviceDetailIndex.toString(), index.toString(), true);
      } else {
        setIsDisabled(false);
        updateProcedureValidationStatus(serviceDetailIndex.toString(), index.toString(), proc.processedBy === 'E' ? true
          : !!((proc.procedureStartDate&&proc.unitType&&proc.unitFrequency)));
      }
    });
  }, []);

  useEffect(() => {
    handleProcedureChange(ProcedureSet);
    updateProcedureCodes(serviceDetailIndex, ProcedureSet);
  }, [ProcedureSet]);

  const handleProcedureChange = (updatedProcedure: any) => {
    setProcedureValues(updatedProcedure);
  };

  return (
    <div className={isDisabled
      ? 'table-full-width table-responsive mb-2 disabled'
      : 'table-full-width table-responsive mb-2'}
      data-testid="procedure-div"
    >
      <table className={isDisabled
        ? 'table fs-sm  rounded sortable-table table-bordered table-hover disabled'
        : 'table fs-sm  rounded sortable-table table-bordered table-hover'}
        data-testid="procedure-table"
        summary="Procedure and Diagnosis Codes"
      >
        <thead>
          <tr>
            <th scope="col" className="align-top">Procedure Code </th>
            <th scope="col" className="align-top">Start Date </th>
            <th scope="col" className="align-top">Requested Units</th>
            <th scope="col" className="align-top">Modifier (optional)</th>
            {serviceType.toLowerCase()==='pharmacy' ? (
              <>
                <th scope="col" className="align-top">NDC Code</th>
                <th scope="col" className="align-top">Drug Name</th>
                <th scope="col" className="align-top">Drug Dose</th>
                <th scope="col" className="align-top">Route</th>
                <th scope="col" className="align-top">Frequency</th>
                <th scope="col" className="align-top text-center w-15">Actions</th>
              </>
            )
              : (<th scope="col" className="align-top text-center w-15">Actions</th>)}

          </tr>
        </thead>
        {ProcedureSet.map((item: itemsprops, index: number) => (

          <tbody key={index} hidden={item.processedBy !== 'C'}>
            <tr data-testid="procedure-item">
              <td data-testid="procedure-code">{item.procedureCode}</td>
              <td className="" data-testid="procedure-startDate">
                {item.procedureStartDate !== '' ? new Date(item.procedureStartDate).toLocaleDateString() : null}
              </td>
              <td className="" data-testid="procedure-units">{`${item.unitFrequency} ${item.unitType}`}</td>
              <td className="" data-testid="procedure-modifiers">
                {item.modifier}
                {' '}
                {item.modifier2 && (
                <span>
                  ,
                  {item.modifier2}
                </span>
                )}
              </td>
              {serviceType.toLowerCase()==='pharmacy' ? (
                <>
                  <td className="" data-testid="procedure-NDCCode">{item.NDCCode}</td>
                  <td className="" data-testid="procedure-drugName">{item.drugName}</td>
                  <td className="maxWidth" data-testid="procedure-doseQty">{item.adjustedDrugDosage!==null && item.adjustedDrugDosage!=='' ? item.adjustedDrugDosage : `${item?.doseQty !== undefined && item?.doseQty !== null? item.doseQty : ''} ${item?.doseQtyUnit}`}</td>
                  <td className="" data-testid="procedure-route">{item.route}</td>
                  <td className="" data-testid="procedure-frequency">{item.frequency}</td>
                  <td className="text-center">
                    <OptionMenu
                      item={item}
                      procedureChange={handleProcedureChange}
                      setProcedureSet={setProcedureSet}
                      ProcedureSet={ProcedureSet}
                      index={index}
                      serviceDetailIndex={serviceDetailIndex}
                      admissionStartDate={admissionStartDate}
                      serviceType={serviceType}
                    />
                  </td>
                </>
              ): (
                <td className="text-center">
                  <OptionMenu
                    item={item}
                    procedureChange={handleProcedureChange}
                    setProcedureSet={setProcedureSet}
                    ProcedureSet={ProcedureSet}
                    index={index}
                    serviceDetailIndex={serviceDetailIndex}
                    admissionStartDate={admissionStartDate}
                    serviceType={serviceType}
                  />
                </td>
              )}
            </tr>
          </tbody>

        ))}
      </table>
    </div>
  );
};

export default Procedure;
